/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payabli/view.blocks to change it.
import React from 'react'
import payabliPng from "./payabli.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Payabli({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Provider/Payabli"
  
}) {
  return (<React.Fragment
>
<img
  data-testid="Payabli.Image"
  data-view-path={viewPath}
 alt={""}
 src={payabliPng}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}